import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: 0,
		height: '100%',
	},
	title: {
		marginBottom: theme.spacing(2),
		marginTop: 0,
		fontWeight: 600,
	},
	searchBox: {
		marginBottom: theme.spacing(2),
	},
	tableContainer: {
		marginTop: theme.spacing(2),
		maxHeight: 'calc(100vh - 300px)',
		overflow: 'auto',
	},
	accordionRoot: {
		marginBottom: theme.spacing(1),
		'&:before': {
			display: 'none',
		},
	},
	accordionSummary: {
		backgroundColor: theme.palette.grey[100],
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	accordionDetails: {
		padding: theme.spacing(2),
		display: 'block',
	},
	fieldLabel: {
		fontWeight: 600,
		marginRight: theme.spacing(1),
		minWidth: 150,
		display: 'inline-block',
	},
	fieldValue: {
		marginBottom: theme.spacing(1),
	},
	chip: {
		margin: theme.spacing(0.5),
	},
	nestedAccordion: {
		marginTop: theme.spacing(1),
		backgroundColor: theme.palette.grey[50],
	},
	jsonView: {
		backgroundColor: theme.palette.grey[100],
		padding: theme.spacing(2),
		borderRadius: theme.shape.borderRadius,
		maxHeight: 400,
		overflow: 'auto',
		fontFamily: 'monospace',
		fontSize: '0.875rem',
	},
	statsBox: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		borderRadius: theme.shape.borderRadius,
	},
}));

